// About.js
import React from 'react';

function About() {
  return (
    <div>
      <h2>About Us</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla ac
        tincidunt tortor, nec facilisis elit. Vestibulum id sapien non quam
        tincidunt viverra. Sed euismod, purus eu varius dictum, libero turpis
        mattis dolor, vel scelerisque erat turpis a libero.
      </p>
    </div>
  );
}

export default About;
